export function getDateFromStatusMessage(message?: string): string | undefined {
  if (!message) return undefined;

  // Matches dates with 1-2 digit days and months, and 2-4 digit years, separated by -, . or /.
  const m = message.match(/(\d{1,2})[.\-/](\d{1,2})[.\-/](\d{2,4})/);
  if (!m) return undefined;

  const [, dd = "", mm = "", yyyy = ""] = m;
  const y = yyyy.length === 2 ? `20${yyyy}` : yyyy;
  const d = dd.padStart(2, "0");
  const mo = mm.padStart(2, "0");

  const D = Number(d),
    M = Number(mo),
    Y = Number(y);
  if (D < 1 || D > 31 || M < 1 || M > 12 || Y < 1900) return undefined;

  // ISO-format yyyy-MM-dd
  return `${y}-${mo}-${d}`;
}
